import React, { useState, useEffect } from 'react'
import './TableSelector.css'
import { getDatabase, onValue, ref } from 'firebase/database'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faArrowAltCircleRight,
	faArrowCircleLeft,
} from '@fortawesome/free-solid-svg-icons'

const TableSelector = (props) => {
	const [page, setPage] = useState(1)
	const [tables, setTables] = useState([])
	const [tableRange, setTableRange] = useState([])
	useEffect(() => {
		setTableRange(
			Array.from({ length: 50 }, (v, k) => k + ((page - 1) * 50 + 1)).map(
				(number) => {
					return {
						no: number,
						selected: props.data.tableNo === number ? true : false,
						taken: tables.some(user => user.table === number)
					}
				}
			)
		)
	}, [page, props.data.tableNo, tables])
	useEffect(() => {
		console.log('Trigger 1')
		const db = getDatabase()
		onValue(ref(db, 'tables/'), (snapshot) => {
			if(snapshot.exists()){
				setTables(Object.entries(snapshot.val()).map(([table, uid]) => {
					return { table: Number(table), uid: uid }
				}))
			}
		})
	}, [])
	const handlePagnationChange = (direction) => {
		if (direction === 'left') {
			if (page !== 1) {
				setPage((currentPage) => currentPage - 1)
			}
		}
		if (direction === 'right') {
			if (page < 20) {
				setPage((currentPage) => currentPage + 1)
			}
		}
	}
	return (
		<>
			{props.data.tableNo?<h3>Valt bordsnummer: {props.data.tableNo}</h3>:<h3>Välj bordsnummer!</h3>}
			<section className="TableSelector">
				{tableRange.map((table) => (
					<button
						className={table.selected ? 'TableButtonActive' : null}
						value={table.no}
						onClick={(e) => props.data.setTableNo(Number(e.target.value))}
						disabled={table.taken}
					>
						{table.no}
					</button>
				))}
			</section>
			<section className="Pagnation">
				<button onClick={() => handlePagnationChange('left')}>
					<FontAwesomeIcon icon={faArrowCircleLeft} />
				</button>

				<button onClick={() => handlePagnationChange('right')}>
					<FontAwesomeIcon icon={faArrowAltCircleRight} />
				</button>
			</section>
		</>
	)
}
export default TableSelector
